import { cn } from 'lib/utils';

export default function PatternBackground({ className, opacity = 'opacity-[0.07]' }) {
  return (
    <div
      className={cn('absolute inset-0 pointer-events-none overflow-hidden', opacity, className)}
      aria-hidden="true"
    >
      <svg
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 400 400"
        preserveAspectRatio="xMidYMid slice"
      >
        <defs>
          <pattern
            id="indian-pattern"
            x="0"
            y="0"
            width="60"
            height="60"
            patternUnits="userSpaceOnUse"
          >
            {/* Diamond */}
            <path
              d="M30 5 L55 30 L30 55 L5 30 Z"
              fill="none"
              stroke="#6B3A2A"
              strokeWidth="0.8"
            />
            {/* Inner diamond */}
            <path
              d="M30 15 L45 30 L30 45 L15 30 Z"
              fill="none"
              stroke="#C4873B"
              strokeWidth="0.5"
            />
            {/* Center dot */}
            <circle cx="30" cy="30" r="2" fill="#6B3A2A" />
            {/* Corner dots */}
            <circle cx="0" cy="0" r="1.5" fill="#C4873B" />
            <circle cx="60" cy="0" r="1.5" fill="#C4873B" />
            <circle cx="0" cy="60" r="1.5" fill="#C4873B" />
            <circle cx="60" cy="60" r="1.5" fill="#C4873B" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#indian-pattern)" />
      </svg>
    </div>
  );
}
